import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";

const mapToOptions = (data, labelKey = "name", valueKey = "code") => {
  return data.map((item) => ({ label: item[labelKey], value: item[valueKey] }));
};

export const getQuiz = async () => {
  try {
    const response = await axiosInstance.get("quizzes/", {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response?.data?.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      if (decryptedData?.data) {
        return mapToOptions(decryptedData.data, "title", "id");
      }
    }
    return [];
  } catch (error) {
    console.error("Error fetching Quiz:", error);
    throw new Error("Failed to fetch Quiz");
  }
};

export const addQuestion = async (questionData) => {
  try {
    const jsonData = Object.fromEntries(questionData.entries()); 
    const response = await axiosInstance.post("questions", jsonData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding Question", error);
    throw new Error("Failed to add Question");
  }
};

export const getQuestion = async () => {
  try {
    const response = await axiosInstance.get("questions", {
      headers: {
        "Content-Type": "application/json",
      },
    });
     if (response && response.data && response.data.encryptedData) {
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData;
    }
    return [];
  } catch (error) {
    console.error("Error fetching Question", error);
    throw new Error("Failed to fetch Question");
  }
};

export const updateQuestion = async (questionId, questionData) => {
  try {
    const jsonData = Object.fromEntries(questionData.entries());
    const response = await axiosInstance.put(`questions/${questionId}`,jsonData);
    return response;
  } catch (error) {
    console.error("Error updating question:", error);
    throw error;
  }
};

export const deleteQuestion = async (id) => {
  try {
    const response = await axiosInstance.delete(`/questions/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to delete Question.";
    console.error("Error in Question:", errorMessage);
    throw new Error(errorMessage);
  }
};